import { useCallback } from "react";

import { type RecoilState, useRecoilState } from "recoil";

import { type MyLensesLensCta } from "../../gql-generated/types";

export const useLensCta = (
    lensCtaState: RecoilState<MyLensesLensCta | null>,
): {
    lensCta: MyLensesLensCta | null;
    setLensCta: (lensCta: MyLensesLensCta) => void;
} => {
    const [lensCta, setLensCta] = useRecoilState(lensCtaState);
    const setLensCtaMemo = useCallback(
        (lensCta: MyLensesLensCta) => {
            setLensCta(lensCta);
        },
        [setLensCta],
    );
    return { lensCta, setLensCta: setLensCtaMemo };
};
